import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useModalityCategoryValue } from "@FillInTableContainer/shared/context/ModalityCategoryContext";
import {
  useTableCreatorFocusStatus,
  DEFAULT_FOCUS_STATUS,
} from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import {
  useTableCreatorPositionInfo,
  DEFAULT_POSITION_INFO,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import {
  ValidatedInfoList,
  useValidatedInTableCreator,
} from "@FillInTableContainer/shared/context/ValidatedInTableCreatorContext";
import { useEntryDataValue } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

interface Returns {
  handleCheckValidationFull: () => boolean;
}

export const useCheckValidationInPatentTableCreator = (): Returns => {
  const entryData = useEntryDataValue(getPressIdFromURL());
  const { updateModalityCategory } = useModalityCategoryValue();
  const { changeValidatedInfo } = useValidatedInTableCreator();
  const { changeInfo } = useTableCreatorPositionInfo();
  const { changeFocusStatus } = useTableCreatorFocusStatus();

  const checkModalityCategory = () => {
    const drugProfileTableList =
      entryData?.[ENTRY_DATA_SECTION_KEYS.patent]?.["Drug Profile"];
    const modalityValues = drugProfileTableList?.map((table) =>
      table.Modality.value?.map((shell) => shell.text),
    );

    const valueInfo = modalityValues?.flatMap((table, tableIndex) =>
      table.map((shell) => {
        if (updateModalityCategory[shell] === "") {
          return {
            groupTableKey: "Drug Profile",
            groupTableIndex: 0,
            tableKey: "Drug",
            tableIndex,
            groupShellKey: null,
            groupShellIndex: 0,
            shellKey: "Modality",
            shellIndex: 0,
            valueIndex: null,
            type: "alert",
            container: "shell",
          };
        }
        return null;
      }),
    );
    return valueInfo?.filter((item) => item !== null);
  };

  const handleCheckValidationFull = () => {
    if (checkModalityCategory()?.length === 0) {
      changeInfo(DEFAULT_POSITION_INFO);
      changeFocusStatus(DEFAULT_FOCUS_STATUS);
      return true;
    }

    const validatedList = [...(checkModalityCategory() || [])];

    changeValidatedInfo(validatedList as ValidatedInfoList);
    return false;
  };

  return {
    handleCheckValidationFull,
  };
};
